import PageLoader from '@/components/atoms/PageLoader.vue'
import PageCard from '@/components/atoms/PageCard.vue'
import PageText from '@/components/atoms/PageText.vue'
import ContentBox from '@/components/atoms/ContentBox.vue'
import Drawer from './Drawer.vue'
import DashboardIcon from './DashboardIcon.vue'

import type { App } from 'vue'

export default (app: App) => {
    app.component('DashboardPageLoader', PageLoader)
    app.component('DashboardPageCard', PageCard)
    app.component('DashboardPageText', PageText)
    app.component('DashboardContentBox', ContentBox)
    app.component('DashboardDrawer', Drawer)
    app.component('DashboardIcon', DashboardIcon)
}
